import React, { useState, useEffect, memo } from 'react'
import "./filter.css"
import FilterButton from './FilterButton'


const FilterBar = ({ duonutCategories, setDuonutCategories, isAllSelected, setIsAllSelected }) => {

   const handleClick = () => {
      if (duonutCategories.length < 1) return
      setIsAllSelected(!isAllSelected)
      if (isAllSelected === true) {
         let updatedCategories = duonutCategories.map(cat => {
            return { ...cat, isSelected: false }
         })
         setDuonutCategories(updatedCategories)
      } else {
         let updatedCategories = duonutCategories.map(cat => {
            return { ...cat, isSelected: true }
         })
         setDuonutCategories(updatedCategories)
      }
   }

   const handleFilterItemClick = (name, isSelected) => {
      let updatedCategories = duonutCategories.map(cat => {
         return cat.name === name ? { ...cat, isSelected: !isSelected } : { ...cat }
      })
      setDuonutCategories(updatedCategories)
   }

   useEffect(() => {
      if (duonutCategories.length < 1) return
      let totalSelected = 0
      duonutCategories.map(cat => {
         if(cat.isSelected === true) totalSelected+=1
      })
      totalSelected ===  duonutCategories.length ? setIsAllSelected(true) : setIsAllSelected(false)
   }, [duonutCategories])

   return (
      <div className='filterContainer'>
         <div className="left">

            <div className='filter'
               onClick={handleClick} style={isAllSelected ? { backgroundColor: '#35F9CA', border: '1px solid black' } : {}}
            >
               <span> All </span>
            </div>
            {
               duonutCategories.map((item, i) => {
                  return <FilterButton key={i}
                     {...item}
                     handleFilterItemClick={handleFilterItemClick}
                     setDuonutCategories={setDuonutCategories}
                     duonutCategories={duonutCategories} />
               })
            }
         </div>
         <div className="right">
            <span style={{ fontWeight: 700, fontSize: '16px' }} className='sortby-text' >sort by : </span>
            <span style={{ color: 'black', fontSize: '14px', margin: '0' }}>date</span>
            <span style={{ color: 'black', fontSize: '14px', margin: '0 16px 0 16px' }}>|</span>
            <span style={{ color: 'black', fontSize: '14px', margin: '0' }}> views</span>
         </div>
      </div>
   )
}

export default memo(FilterBar)